import { render, staticRenderFns } from "./screen-tabs.vue?vue&type=template&id=afe31aa2&scoped=true"
import script from "./screen-tabs.vue?vue&type=script&lang=js"
export * from "./screen-tabs.vue?vue&type=script&lang=js"
import style0 from "./screen-tabs.vue?vue&type=style&index=0&id=afe31aa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe31aa2",
  null
  
)

export default component.exports